
import { Component, Mixins } from "vue-property-decorator";
import { DepartmentGroup } from "../../../domain/department";

@Component
export default class DepartmentGroupSelectableMixin extends Mixins() {
  data(): any {
    return {
      selectedDepartmentGroup: null,
    };
  }
  selectedDepartmentGroup: DepartmentGroup;
}
